import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SelectedModelInput from '../../components/SelectedModelInput';
import { useAxios } from '../../utils/hook/useAxios';
import './mc-forms.css';

function VoitureConfigPage() {
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedMarque, setSelectedMarque] = useState(null);
  const [modelId, setModelId] = useState(null);
  const [modelName, setModelName] = useState(null);
  const [resetInput, setResetInput] = useState(true);
  const [vehicleData, setVehicleData] = useState({});
  const [hasUpdate, setHasUpdate] = useState(false);
  const { voitureId } = useParams();

  const axios = useAxios();

  // Fonctions de rappel pour récupérer les valeurs sélectionnées
  useEffect(() => {
    let fetchReviews = async () => {
      let datavehicule = window.localStorage.getItem('VehicleStorage');
      datavehicule = JSON.parse(datavehicule);
      setVehicleData(datavehicule);
      console.log(datavehicule);
      const response = await axios.get('/vehicles/searchbyid/' + voitureId);
      if (response.data) {
        setVehicleData(response.data);
        setModelId(response.data.modeleId);
        let datavehicle = JSON.stringify(response.data);
        window.localStorage.setItem('VehicleStorage', datavehicle);
      }
    };
    fetchReviews();
  }, []);

  function handleConfirm() {
    const vData = { ...vehicleData };
    vData.modelId = modelId;
    setVehicleData(vData);
    let datavehicule = vData;
    datavehicule = JSON.stringify(datavehicule);
    window.localStorage.setItem('VehicleStorage', datavehicule);

    window.location.href = '/advancedconfig/' + vData.id;
  }

  const handleModelSelection = (model) => {
    setModelId(model.id);
    setModelName(model.modele);
  };
  function handleModifier() {
    setHasUpdate(true);
  }

  function handleAnnuler() {
    setHasUpdate(false);
  }

  const brand = vehicleData?.VehicleModel?.marque;
  const model = vehicleData?.VehicleModel?.modele;

  return (
    <main className="mc-home mc-form-page">
      <div className="mc-form-shell mc-form-shell--narrow">
        <div className="mc-stepper" aria-label="Progression de l'inscription">
          <div className="mc-stepper-top">
            <span>Inscrire ma voiture</span>
            <span>Étape 1 sur 4</span>
          </div>
          <div
            className="mc-stepper-bar"
            role="progressbar"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div className="mc-stepper-fill" style={{ width: '25%' }}></div>
          </div>
        </div>

        <section className="mc-form-card">
          <span className="mc-section-kicker">VOTRE VÉHICULE</span>
          <h1 className="mc-form-title">Confirmez le modèle de votre voiture</h1>
          <p className="mc-form-subtitle">
            Vérifiez la marque et le modèle avant de continuer. Vous pouvez les modifier si besoin.
          </p>

          {hasUpdate ? (
            <div className="mc-field">
              <SelectedModelInput
                handleSelectModel={handleModelSelection}
                resetInput={resetInput}
              ></SelectedModelInput>
            </div>
          ) : (
            vehicleData && (
              <div className="mc-model-summary">
                {brand || model ? (
                  <>
                    {brand && <span className="mc-model-badge mc-model-badge--brand">{brand}</span>}
                    {model && <span className="mc-model-badge mc-model-badge--model">{model}</span>}
                  </>
                ) : (
                  <p className="mc-model-empty">Aucun modèle sélectionné pour le moment.</p>
                )}
              </div>
            )
          )}

          <div className="mc-form-toolbar">
            {!hasUpdate ? (
              <button
                type="button"
                className="mc-btn mc-btn--secondary mc-btn--sm"
                onClick={handleModifier}
              >
                <ion-icon name="create-outline"></ion-icon>
                Modifier le modèle
              </button>
            ) : (
              <button
                type="button"
                className="mc-btn mc-btn--ghost mc-btn--sm"
                onClick={handleAnnuler}
              >
                Annuler la modification
              </button>
            )}
          </div>

          <div className="mc-form-alert" role="status">
            <ion-icon name="time-outline"></ion-icon>
            <span>Dans quelques minutes, votre annonce sera mise en ligne.</span>
          </div>

          <div className="mc-form-actions">
            <span></span>
            <button type="button" className="mc-btn mc-btn--primary" onClick={handleConfirm}>
              Confirmer
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}

export default VoitureConfigPage;
